import { defaultPalette } from '@guryou/colors';

const accordionOverrides = {
  MuiAccordion: {
    root: {
      '& .MuiAccordion-root': {
        backgroundColor: defaultPalette.grey[100],
      },

      '& .MuiCollapse-container': {
        padding: 0,
      },
    },
  },
  MuiAccordionDetails: {
    root: {
      padding: 0,
    },
  },
  MuiAccordionSummary: {
    root: {
      padding: '0 4px',
    },
    content: {
      '&.Mui-expanded': {
        margin: '12px 0',
      },
    },
  },
};

export { accordionOverrides };
